import React, { useState } from 'react';
import { Button, Modal, Spin } from 'antd';
import s from './s.module.less';
import TestimonialSection from './TestimonialSection';
import image1 from './image1.png';
import image2 from './image2.png';
import image3 from './image3.png';
import image4 from './image4.png';
import image5 from './image5.png';
import image6 from './image6.png';
import image7 from './image7.png';
import useGetPPATopProviders from 'hooks/useGetPPATopProviders';
import commonS from 'styles/common.module.less';
import { getProviderNameDisplay } from 'utils/provider';
import { getPPAHelloKlarityHost, isMobile } from 'utils/common';
import avatar5 from './provider1.png';
import avatar4 from './provider2.png';
import avatar3 from './provider3.png';
import avatar2 from './provider4.png';
import avatar1 from './provider5.png';

// interface IProps {
//     onNext: () => void;
// }

const Step2 = () => {
    const [providerList, loading] = useGetPPATopProviders();
    const [showProviderModal, setShowProviderModal] = useState(false);
    const [iframeSrc, setIframeSrc] = useState('');

    const features = [
        'No-show support — tools to help reduce missed appointments and protect your time',
        'Easily manage patient growth velocity',
        'Accepts major insurance to maximize your case load',
    ];

    const testimonials = [
        {
            id: 1,
            name: 'Ben Timbs, PhD, FNP-BC',
            date: 'Feb 2024',
            text: 'I have enjoyed my relationships with Klarity. As an independent practitioner, I have been provided with the authonomy to apply evidence-based practice without physician oversight when caring for my patients. Klarity has provided a platform for independent business, while still being available for support when needed.',
            avatar: avatar1,
        },
        {
            id: 2,
            name: 'Michael Chen, NP',
            date: 'Mar 2024',
            text: 'The support team at Klarity is exceptional. They helped me set up my profile and optimize my booking availability.',
            avatar: avatar4,
        },
        {
            id: 3,
            name: 'Margaret Gallagher, PhD,FNP-BC',
            date: 'Feb 2024',
            text: 'I have enjoyed my relationships with Klarity. As an independent practitioner, I have been provided with the authonomy to apply evidence-based practice without physician oversight when caring for my patients. Klarity has provided a platform for independent business, while still being available for support when needed.',
            avatar: avatar3,
        },
        {
            id: 4,
            name: 'Christine Forge, FNP-C, PMHNP-BC',
            date: 'Aug 2024',
            text: 'Joining Klarity has been the best decision I have made for my career. I am able to have control over my practice to be able to provide the best care possible. The Klarity platform has provided me with a full schedule of patients and the support team is always ready to help when needed. Klarity team members are always evolving the practice to make it better for both practitioners and patients.',
            avatar: avatar2,
        },
        {
            id: 5,
            name: 'David Kim, MD',
            date: 'Apr 2024',
            text: 'Patient satisfaction scores have improved since using Klarity. The booking system is seamless and professional.',
            avatar: avatar5,
        },
    ];

    if (loading) {
        return <Spin spinning />;
    }

    return (
        <div className={s.wrap}>
            <Modal
                width={isMobile() ? '75vw' : '50vw'}
                className={`${commonS.modalFixHeightWrap} ${s.providerModal}`}
                open={showProviderModal}
                onCancel={() => setShowProviderModal(false)}
                footer={null}
                destroyOnClose
            >
                <div className={s.iframeWrap}>
                    {/* <div className={s.iframeMask} /> */}
                    <iframe className={s.iframe} src={`${iframeSrc}?isPreview=true`} title="provider profile" />
                </div>
            </Modal>
            <div className={s.content}>
                {/* Header Section */}
                <div className={s.header}>
                    <h1>List on Klarity Health — sees 30+ bookings in the first month</h1>
                    <div className={s.headerDescription}>
                        Join Klarity Health to reach thousands of patients searching for care every day.
                        Pay only when a new patient books with you.
                    </div>
                </div>

                {/* Main Content */}
                <div className={s.mainContent}>
                    {/* Features Section */}
                    <div className={s.section}>
                        <h2>See how providers grow with Klarity</h2>
                        <div className={s.featuresContainer}>
                            {features.map((feature, index) => (
                                <div key={index} className={s.featureItem}>
                                    <div className={s.checkIcon}>
                                        <div className={s.checkCircle}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M3.3335 7.99984L6.66683 11.3332L13.3335 4.6665" stroke="#0E62F4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </div>
                                    </div>
                                    <span className={s.featureText}>{feature}</span>
                                </div>
                            ))}
                            {/* Insurance Logos */}
                            <div className={s.insuranceLogos}>
                                <img src={image1} alt="Insurance Logo 1" className={s.logoImage} />
                                <img src={image2} alt="Insurance Logo 2" className={s.logoImage} />
                                <img src={image3} alt="Insurance Logo 3" className={s.logoImage} />
                                <img src={image4} alt="Insurance Logo 4" className={s.logoImage} />
                                <img src={image5} alt="Insurance Logo 5" className={s.logoImage} />
                                <img src={image6} alt="Insurance Logo 6" className={s.logoImage} />
                                <img src={image7} alt="Insurance Logo 7" className={s.logoImage} />
                                <div className={s.moreText}>And more</div>
                            </div>
                        </div>
                    </div>

                    {/* Providers Section */}
                    {
                        providerList && providerList.length > 0 && (
                            <div className={s.section}>
                                <h2>Explore how top providers show up on Klarity Health</h2>
                                <div className={s.providersGrid}>
                                    {providerList?.map((provider) => (
                                        <div key={provider.id} className={s.providerCard}>
                                            <div className={s.providerInfo}>
                                                <div className={s.providerAvatar}>
                                                    <img src={provider.photos[0]} className={s.avatarPlaceholder} />
                                                </div>
                                                <div className={s.providerDetails}>
                                                    <h3>{getProviderNameDisplay(provider)}</h3>
                                                    <p>{provider.credential}</p>
                                                </div>
                                            </div>
                                            <div className={s.specialty}>{provider.specialty.join(',')}</div>
                                            <div className={s.providerActions}>
                                                <Button
                                                    className={s.viewProfileBtn}
                                                    onClick={() => {
                                                        setIframeSrc(`${getPPAHelloKlarityHost()}/provider/${provider.slug}`);
                                                        setShowProviderModal(true);
                                                    }}
                                                >View profile
                                                </Button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )
                    }

                    {/* Testimonials Section */}
                    <TestimonialSection testimonials={testimonials} />
                </div>
            </div>
        </div>
    );
};

export default Step2;
